import React, { ReactElement, useMemo } from "react";
import { QualityHubAdminRootViewProps } from "./QualityHubAdminRootView.types";
import { renderAdminTitle } from "src/admin/common/Title";
import { localize } from "src/l10n";
import { Breadcrumbs, PageHeader } from "src/ui";
import { Pivot, PivotItem } from "@fluentui/react";
import { ResourceTagList } from "src/components";
import { QualityHubListsView } from "../QualityHubListsView";

/**
 * Renders the root view for the administration of the Quality Hub.
 *
 * @param {QualityHubAdminRootViewProps} props - The component props
 * @returns {ReactElement | null} The rendered view
 */
function QualityHubAdminRootView({
}: QualityHubAdminRootViewProps): ReactElement | null {
    const l10n = useMemo(() => ({
        appName: localize("appQualityHub"),
        tags: localize("RESOURCE_TAGS"),
    }), []);

    const breadcrumbs = useMemo(() => [
        { key: 2
        , link: "/admin"
        , text: localize("Administration")
        },
        { key: 3
        , link: "/admin/quality-hub"
        , text: l10n.appName
        },
    ], [l10n.appName]);

    return (
        <div id="QualityHubAdminRootView">
            {renderAdminTitle(l10n.appName)}

            <Breadcrumbs displayInstance={true}
                         items={breadcrumbs}
                         useGlobalBreadcrumbs={true} />

            <PageHeader title={l10n.appName} />

            <Pivot overflowBehavior="menu">

                <PivotItem headerText={localize("QH_LISTS")}>
                    <QualityHubListsView hidePageHeader={true} />
                </PivotItem>

                <PivotItem headerText={l10n.tags}>
                    <ResourceTagList />
                </PivotItem>

            </Pivot>
        </div>
    );
}

export default QualityHubAdminRootView;

